import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { BookService, BookServiceQueryParams } from "../types";

interface BookServiceState {
  bookServiceList: BookService[];
  bookServiceTotal: number;
  bookServiceDetail: BookService[];
}

const initialState: BookServiceState = {
	bookServiceList: [],
	bookServiceTotal: 0,
	bookServiceDetail: [],
};

export const bookServiceSlice = createSlice({
	name: "bookService",
	initialState,
	reducers: {
		setListBookService: (state, action) => {
			state.bookServiceList = action.payload.data;
			state.bookServiceTotal = action.payload.total;
		},
		setDetailBookService: (state, action) => {
			state.bookServiceDetail = action.payload.data;
		},
		deleteBookService: (state, action) => {
			const { id } = action.payload;
			state.bookServiceList = state.bookServiceList.filter(el => el.id !== id);
			state.bookServiceTotal = state.bookServiceTotal - 1;
		},
		changeStatusBookService: (state, action) => {
			const { id, status } = action.payload;
			const index = state.bookServiceList.findIndex(el => el.id === id);
			state.bookServiceList[index].status = status;
		},
	},
});

export const selectBookServiceList = (state: RootState) =>
	state.bookService.bookServiceList;
export const selectBookServiceTotal = (state: RootState) =>
	state.bookService.bookServiceTotal;
export const selectBookServiceDetail = (state: RootState) =>
	state.bookService.bookServiceDetail;

export const {
	setListBookService,
	setDetailBookService,
	deleteBookService,
	changeStatusBookService,
} = bookServiceSlice.actions;

export interface GetListBookServicePayload {
  query: BookServiceQueryParams;
}
export const getListBookServiceAsync = createAction(
	"bookService/getListBookServiceAsync",
	(payload: GetListBookServicePayload) => ({
		payload: payload || {},
	}),
);

export default bookServiceSlice.reducer;
